var angular = require('angular');

import moment from 'moment';
import licenseModule from '../../license.module';
import template from './licenseInstanceDetail.component.html';
import style from './licenseInstanceDetail.component.css';

export default licenseModule.component('licenseInstanceDetail', {
    template,
    style,
    controller: [
        '$filter',
        'modalService',
        'LicenseManagementService',
        'instanceConstants',
        'asLoadingMask',
        licenseInstanceDetailComponent
    ],
    bindToController: true,
    bindings: {
        instance: '<',
        appspaceIdSummary: '<',
        callback: '&'
    }
});

function licenseInstanceDetailComponent(
    $filter,
    modalService,
    LicenseManagementService,
    instanceConstants,
    asLoadingMask
) {
    var vm = this;
    vm.$onChanges = change;
    vm.options = {
        showIcon: true
    };

    asLoadingMask.show();
    vm.onlineStatusClass = 'online';
    vm.getValue = 30;

    function change(changeObj) {
        // $onChanges only receives the bindings that actually changed, so
        // changeObj.instance is absent whenever appspaceIdSummary or callback
        // changes on its own -- reading .currentValue off it then throws.
        if (changeObj.instance && changeObj.instance.currentValue) {
            render();
        }
    }

    function render() {
        var tooltip = {};
        var tooltipStatus = {};
        tooltip.title = 'Connection Status';
        vm.tooltip = tooltip;

        // Show if server is online/offline icon for both static and dynamic
        if (vm.instance.online === undefined) {
            vm.showAlert = true;
            vm.onlineStatusClass = 'offline';
            tooltip.content =
                'An error has occurred. Please try again later. If the problem persists, please contact Appspace Support.';
        } else if (vm.instance.online == true) {
            vm.showAlert = true;
            vm.onlineStatusClass = 'online';

            if (vm.instance.allocationType == 'dynamic') {
                tooltip.content =
                    'ONLINE. Last sync to Appspace Cloud on  ' +
                    $filter('datetime')(vm.instance.lastSync);
            } else if (vm.instance.allocationType == 'static') {
                tooltip.content =
                    'ONLINE. Last sync to Appspace Cloud on  ' +
                    $filter('datetime')(vm.instance.lastSync);
            }
        } else if (vm.instance.online == false) {
            vm.showAlert = true;
            vm.onlineStatusClass = 'offline';

            if (vm.instance.allocationType == 'dynamic') {
                tooltip.content =
                    'OFFLINE. Last sync to Appspace Cloud on  ' +
                    $filter('datetime')(vm.instance.lastSync);
            } else if (vm.instance.allocationType == 'static') {
                tooltip.content = 'OFFLINE. Not connected to Appspace Cloud.  ';
            }
        }

        if (vm.instance.allocationType == 'dynamic') {
            vm.typeOfServer = '';

            // Show status labels for dynamic server
            if (vm.instance.status === undefined || vm.instance.status == '') {
                vm.showStatusLabel = 'Unavailable';
                vm.alertClass = 'alertUnavailable';
                tooltipStatus.content =
                    'An error has occurred. Please try again later. If the problem persists, please contact Appspace Support.';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'warning') {
                vm.showStatusLabel = 'Warning';
                vm.alertClass = 'alertWarning';
                tooltipStatus.content =
                    'WARNING: Server failed to sync to Appspace Cloud. If the server fails to connect for more than 24 hours, your devices will stop receiving content updates.';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'restricted') {
                var todayDate = moment(new Date()).utc();
                var lastSync = moment(vm.instance.lastSync);
                var fourteenDays = lastSync.add(14, 'days').format();
                var countDown14Days = todayDate.from(fourteenDays, true);

                vm.showStatusLabel = 'Restricted';
                vm.alertClass = 'alertRestricted';

                tooltipStatus.content =
                    'WARNING: Server failed to sync to Appspace Cloud for more than 7 days. None of your devices can receive content updates until the server reconnects to Appspace. You have ' +
                    countDown14Days +
                    ' before you are locked out from this console.';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'inactive') {
                vm.showStatusLabel = 'Disabled';
                vm.alertClass = 'alertDisabled';
                tooltipStatus.content =
                    'WARNING: Server failed to sync with Appspace Cloud for more than 14 days. Please reconnect server to Appspace Cloud or reactivate your server license.';
                vm.tooltipStatus = tooltipStatus;
            }
        } else if (vm.instance.allocationType == 'static') {
            vm.typeOfServer = 'static allocation ';
            var today = moment(new Date()).utc();
            var expireDate = moment(vm.instance.expireDate);
            var thirtyDaysBefore = today.from(expireDate, true);

            var diffinDays = expireDate.diff(today, 'days');
            if (vm.instance.status === undefined || vm.instance.status == '') {
                vm.showStatusLabel = 'Unavailable';
                vm.alertClass = 'alertUnavailable';
                tooltipStatus.content =
                    'An error has occurred. Please try again later. If the problem persists, please contact Appspace Support.';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'warning') {
                vm.showStatusLabel = 'Expiring';
                vm.alertClass = 'alertWarning';
                if (diffinDays <= 30) {
                    tooltipStatus.content =
                        'Your server license will expire in ' +
                        thirtyDaysBefore +
                        '. Please renew the server license or your devices will stop receiving content updates.';
                    vm.tooltipStatus = tooltipStatus;
                }
            } else if (vm.instance.status == 'restricted') {
                vm.showStatusLabel = 'Expired';
                vm.alertClass = 'alertRestricted';
                tooltipStatus.content =
                    'Your server license has expired. None of your devices will receive content updates until this server is re-licensed.';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'inactive') {
                vm.showStatusLabel = 'Expired';
                vm.alertClass = 'alertInactive';
                tooltipStatus.content = 'This server license is inactive.';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'pending-registration') {
                vm.tooltipLink = true;
                vm.showStatusLabel = 'Pending Receipt';
                vm.alertClass = 'alertPending';
                tooltipStatus.content = 'Pending registration';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'pending-deactivate') {
                vm.tooltipLink = true;
                vm.showStatusLabel = 'Pending Receipt';
                vm.alertClass = 'alertPending';
                tooltipStatus.content = 'Pending deactivation';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'pending-id-increase') {
                vm.tooltipLink = true;
                vm.showStatusLabel = 'Pending Receipt';
                vm.alertClass = 'alertPending';
                tooltipStatus.content = 'Pending ID increase';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'pending-id-decrease') {
                vm.tooltipLink = true;
                vm.showStatusLabel = 'Pending Receipt';
                vm.alertClass = 'alertPending';
                tooltipStatus.content = 'Pending ID decrease';
                vm.tooltipStatus = tooltipStatus;
            } else if (vm.instance.status == 'pending-renewal') {
                vm.tooltipLink = true;
                vm.showStatusLabel = 'Pending Receipt';
                vm.alertClass = 'alertPending';
                tooltipStatus.content = 'Pending renewal';
                vm.tooltipStatus = tooltipStatus;
            }

            if (
                vm.instance.allocated.subscription.deviceId === 0 &&
                vm.instance.allocated.perpetual.deviceId > 0
            ) {
                vm.allocatedDevices = vm.instance.allocated.perpetual.deviceId;
            } else {
                vm.allocatedDevices =
                    vm.instance.allocated.subscription.deviceId;
            }

            if (
                vm.instance.allocated.subscription.premiumUserId === 0 &&
                vm.instance.allocated.perpetual.premiumUserId > 0
            ) {
                vm.allocatedPlatformUsers =
                    vm.instance.allocated.perpetual.premiumUserId;
            } else {
                vm.allocatedPlatformUsers =
                    vm.instance.allocated.subscription.premiumUserId;
            }
        } else if (
            vm.instance.allocationType === undefined ||
            vm.instance.allocationType == ''
        ) {
            vm.typeOfServer = '( Unknown server type )';
        }

        vm.openServer = function() {
            if (vm.instance.instanceType != 'cloud') {
                modalService
                    .openCustom({
                        component: 'licenseServer',
                        size: 'lg',
                        resolve: {
                            reset: true,
                            data: function() {
                                return vm.instance;
                            }
                        }
                    })
                    .then(
                        function() {
                            vm.callback({ $value: 'close' });
                        },
                        function() {}
                    );
            }
        };

        // Context Menu for DYNAMIC SERVER and STATIC SERVER
        var items = [];
        var item;

        if (vm.instance.instanceType == 'on-premise') {
            if (vm.instance.allocationType == 'static') {
                item = {
                    label: 'View license',
                    value: 'view-license'
                };
                items.push(item);
            }

            if (
                vm.instance.allocated.perpetual.deviceId > 0 &&
                vm.instance.allocated.perpetual.premiumUserId > 0
            ) {
                item = {
                    label: 'View perpetual IDs',
                    value: 'view-perpetual-ids'
                };
                items.push(item);
            }

            if (
                vm.instance.status == 'pending-registration' ||
                vm.instance.status == 'pending-deactivate' ||
                vm.instance.status == 'pending-id-increase' ||
                vm.instance.status == 'pending-id-decrease' ||
                vm.instance.status == 'pending-renewal'
            ) {
                item = {
                    label: 'Enter pending receipt',
                    value: 'pending-receipt'
                };
                items.push(item);
            } else {
                if (vm.instance.allocationType == 'static') {
                    if (vm.instance.licenseStatus == 'renew') {
                        item = {
                            label: 'Renew server license',
                            value: 'renew-license'
                        };
                        items.push(item);
                    }

                    item = {
                        label: 'Manage ID allocation',
                        value: 'reallocation'
                    };
                    items.push(item);
                }
                item = {
                    label: 'Deactivate server license',
                    value: 'deactivate-server-license'
                };
                items.push(item);
            }
        }

        vm.contextMenu = {
            id: 'asuiContextMenuPending',
            menuGroups: [
                {
                    name: 'license',
                    showHeader: false,
                    items: items
                }
            ],
            options: {
                placement: 'left'
            }
        };

        vm.openPendingReceipt = function() {
            modalService
                .openCustom({
                    component: 'licensePendingReceipt',
                    size: 'lg',
                    resolve: {
                        reset: true,
                        data: function() {
                            return vm.instance;
                        }
                    }
                })
                .then(
                    function() {
                        vm.callback({ $value: 'close' });
                    },
                    function() {}
                );
        };

        vm.onItemClick = function(target, group, value) {
            if (value == 'pending-receipt') {
                modalService
                    .openCustom({
                        component: 'licensePendingReceipt',
                        size: 'lg',
                        resolve: {
                            reset: true,
                            data: function() {
                                return vm.instance;
                            }
                        }
                    })
                    .then(
                        function() {
                            vm.callback({ $value: 'close' });
                        },
                        function() {}
                    );
            } else if (value == 'deactivate-server-license') {
                if (vm.instance.allocationType == 'static') {
                    modalService
                        .openCustom({
                            component: 'licenseDeactivateStatic',
                            size: 'lg',
                            resolve: {
                                reset: true,
                                data: function() {
                                    return vm.instance;
                                }
                            }
                        })
                        .then(
                            function() {
                                vm.callback({ $value: 'close' });
                            },
                            function() {}
                        );
                } else {
                    modalService
                        .openCustom({
                            component: 'licenseDeactivateDynamic',
                            size: 'lg',
                            resolve: {
                                reset: true,
                                data: function() {
                                    return vm.instance;
                                }
                            }
                        })
                        .then(
                            function() {
                                modalService
                                    .openCustom({
                                        component:
                                            'licenseDeactivateDynamicConfirmation',
                                        size: 'md',
                                        resolve: {
                                            reset: true,
                                            data: function() {
                                                return vm.instance;
                                            }
                                        }
                                    })
                                    .then(
                                        function() {
                                            vm.callback({ $value: 'close' });
                                        },
                                        function() {}
                                    );
                                vm.callback({ $value: 'close' });
                            },
                            function() {}
                        );
                }
            } else if (value == 'view-license') {
                modalService
                    .openCustom({
                        component: 'licenseViewLicense',
                        size: 'lg',
                        resolve: {
                            reset: true,
                            data: function() {
                                return vm.instance;
                            }
                        }
                    })
                    .then(
                        function() {
                            vm.callback({ $value: 'close' });
                        },
                        function() {}
                    );
            } else if (value == 'view-perpetual-ids') {
                modalService
                    .openCustom({
                        component: 'licenseViewPerpetual',
                        size: 'lg',
                        resolve: {
                            reset: true,
                            data: function() {
                                return vm.instance;
                            }
                        }
                    })
                    .then(
                        function() {
                            vm.callback({ $value: 'close' });
                        },
                        function() {}
                    );
            } else if (value == 'renew-license') {
                modalService
                    .openCustom({
                        component: 'licenseRenewLicense',
                        size: 'lg',
                        resolve: {
                            reset: true,
                            data: function() {
                                return vm.instance;
                            }
                        }
                    })
                    .then(
                        function() {
                            vm.callback({ $value: 'close' });
                        },
                        function() {}
                    );
            } else if (value == 'reallocation') {
                LicenseManagementService.getAppspaceIDSummary().then(function(
                    data
                ) {
                    var appspaceIdSummary = data;
                    modalService
                        .openCustom({
                            component: 'licenseManageReallocation',
                            size: 'lg',
                            resolve: {
                                reset: true,
                                data: function() {
                                    return vm.instance;
                                },
                                appspaceIdSummary: function() {
                                    return appspaceIdSummary;
                                }
                            }
                        })
                        .then(
                            function() {
                                vm.callback({ $value: 'close' });
                            },
                            function() {}
                        );
                });
            }
        };

        if (
            vm.instance.allocationType == 'dynamic' &&
            vm.instance.status == 'pending-deactivate'
        ) {
            var tooltipPendingDeactivation = {};
            vm.tooltipPendingDynamic = tooltipPendingDeactivation;
            vm.disabled = true;
            tooltipPendingDeactivation.content =
                'Pending deactivation. Please go to your Appspace Console and sync this server to complete the deactivation.';
        }

        if (
            vm.instance.allocationType == 'dynamic' &&
            vm.instance.status == 'pending-renewal'
        ) {
            var tooltipPendingRenewal = {};
            vm.tooltipPendingDynamic = tooltipPendingRenewal;
            vm.disabled = true;
            tooltipPendingRenewal.content =
                'Pending sync. Please go to your Appspace Console and sync this server to complete the process.';
        }

        vm.displayMenuOption =
            !vm.instance.deploymentType ||
            vm.instance.deploymentType ==
                instanceConstants.deploymentType.onPremise.name;

        let deploymentTypeConstantObject = Object.values(
            instanceConstants.deploymentType
        ).filter(type => type.name === vm.instance.deploymentType)[0];

        vm.environmentType = deploymentTypeConstantObject
            ? deploymentTypeConstantObject.displayName
            : undefined;

        if (vm.instance.instanceType != 'cloud') {
            vm.actualDeviceUsage = '-';
            vm.actualPlatformUsersUsage = '-';

            var versionValue = vm.instance.version;
            if (versionValue) {
                vm.serverVersion = `Version ${versionValue}`;

                if (
                    versionValue.includes('.') &&
                    parseInt(
                        versionValue.substr(0, versionValue.indexOf('.'))
                    ) >= 7
                ) {
                    vm.actualDeviceUsage = vm.instance.usage.deviceId;
                    vm.actualPlatformUsersUsage =
                        vm.instance.usage.premiumUserId;
                }
            }
        }

        prepareLicenseTypesForRender();

        var date = moment(vm.instance.lastSync);
        if (date.year() == 1) {
            vm.lastSync = 'Never';
        } else {
            vm.lastSync = date.fromNow();
        }
    }

    function prepareLicenseTypesForRender() {
        LicenseManagementService.getAppspaceIDSummary().then(
            function(data) {
                var instanceUserLicenseTypes = angular.copy(
                    data.userLicenseTypes
                );

                var instanceDeviceLicenseTypes = angular.copy(
                    data.deviceLicenseTypes
                );

                var instanceActualUserLicenseTypes = angular.copy(
                    vm.instance.userLicenseTypes
                );

                var instanceActualDeviceLicenseTypes = angular.copy(
                    vm.instance.deviceLicenseTypes
                );

                vm.instanceLicenseTypes = [];

                transformLicenseTypesForRender(
                    instanceUserLicenseTypes,
                    instanceActualUserLicenseTypes
                );
                transformLicenseTypesForRender(
                    instanceDeviceLicenseTypes,
                    instanceActualDeviceLicenseTypes
                );

                asLoadingMask.hide();
            },
            function() {
                console.log(
                    'licenseManagementComponent.getAppspaceIDSummary : Failed to get appspace id summary.'
                );
            }
        );
    }

    function transformLicenseTypesForRender(licenseTypes, actualLicenseTypes) {
        for (let i = 0; i < licenseTypes.length; i++) {
            licenseTypes[i].total =
                licenseTypes[i].subscription.total > 0
                    ? licenseTypes[i].subscription.total
                    : licenseTypes[i].perpetual.total >= 0
                        ? licenseTypes[i].perpetual.total
                        : 0;

            licenseTypes[i].globalUsage =
                licenseTypes[i].subscription.usage > 0
                    ? licenseTypes[i].subscription.usage
                    : licenseTypes[i].perpetual.usage >= 0
                        ? licenseTypes[i].perpetual.usage
                        : 0;

            licenseTypes[i].remaining =
                licenseTypes[i].total - licenseTypes[i].globalUsage < 0
                    ? 0
                    : licenseTypes[i].total - licenseTypes[i].globalUsage;

            licenseTypes[i].allocated = 0;
            licenseTypes[i].instanceUsage = 0;

            vm.showStaticUsage = vm.instance.allocationType == 'static';

            for (let j = 0; j < actualLicenseTypes.length; j++) {
                if (licenseTypes[i].name == actualLicenseTypes[j].name) {
                    licenseTypes[i].allocated =
                        actualLicenseTypes[j].allocated.subscription > 0
                            ? actualLicenseTypes[j].allocated.subscription
                            : actualLicenseTypes[j].allocated.perpetual >= 0
                                ? actualLicenseTypes[j].allocated.perpetual
                                : 0;

                    licenseTypes[i].instanceUsage =
                        actualLicenseTypes[j].usage >= 0
                            ? actualLicenseTypes[j].usage
                            : 0;
                }
            }
        }

        vm.instanceLicenseTypes.push(licenseTypes);
    }
}



// WEBPACK FOOTER //
// ./modules/license/features/license-instance-detail/licenseInstanceDetail.component.js